import Icon from "@mui/material/Icon";

//import AboutUs from "layouts/pages/landing-pages/about-us";
import ContactUs from "layouts/pages/landing-pages/contact-us";
import Inicio from "layouts/pages/inicio";
import Aspecto from "layouts/pages/landing-pages/aspecto";
import Outrasconcepcoes from "layouts/pages/landing-pages/outrasconcepcoes";
import Artigos from "layouts/pages/landing-pages/artigos";

const routes = [
  {
    name: "Inicio",
    icon: <Icon>dashboard</Icon>,
    columns: 1,
    rowsPerColumn: 2,
    collapse: [
      {
        name: "",
        collapse: [
          {
            name: "Inicio",
            route: "/inicio",
            component: <Inicio />,
          },
          {
            name: "Fale Conosco",
            route: "/FaleConosco",
            component: <ContactUs />,
          },
        ],
      },
    ],
  },
  {
    name: "Páginas",
    icon: <Icon>article</Icon>,
    columns: 1,
    rowsPerColumn: 2,
    collapse: [
      {
        name: "listagem páginas",
        collapse: [
          {
            name: "Aspecto legais",
            route: "/aspectolegais",
            component: <Aspecto />,
          },
          {
            name: "Outras concepções",
            route: "/outrasconcepcoes",
            component: <Outrasconcepcoes />,
          },
          {
            name: "Artigos publicados na área",
            route: "/artigos",
            component: <Artigos />,
          },
        ],
      },
    ],
  },
];

export default routes;
